<template>
  <div class="wrapper">
    <div class="header">
      <el-form class="form-style" :model="form1" size="mini" :inline="true">
        <el-form-item label="所属科目" prop="subject_id">
          <el-select v-model="form1.subject_id" placeholder="请选择" clearable>
            <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题库来源">
          <el-select v-model="form1.source_id" filterable placeholder="请选择" clearable>
            <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>

        </el-form-item>

        <el-form-item label="题库名称" prop="title">
          <el-input style="width: 200px" v-model="form1.title" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="所属">
          <el-select @change="changeList" v-model="form1.is_admin" placeholder="请选择">
            <el-option label="平台" value="1"></el-option>
            <el-option label="校区" value="2"></el-option>
          </el-select>
          <!-- <el-select v-model="form1.source_id" filterable placeholder="请选择" clearable>
           
          </el-select> -->

        </el-form-item>

        <el-form-item>
          <el-button class="search_btn" plain size="mini" icon="el-icon-search" @click="search">搜索</el-button>

          <el-button class="search_btn" type="primary" size="mini" icon="el-icon-edit"
            @click="addproblem">新增题库</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="question_wrapper">
      <el-table size="mini" :data="questionlist" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column align="center" width="100" label="序号">
          <template slot-scope="scope">{{ scope.$index + 1 + 20 * (page_no - 1) }}</template>
        </el-table-column>
        <el-table-column align="center" width="100" label="排序号">
          <template slot-scope="scope">{{ scope.row.sort_num }}</template>
        </el-table-column>
        <el-table-column align="center" width="50" label="封面">
          <template slot-scope="scope">
            <el-image style="width: 37.5px; height: 17px" :src="scope.row.cover_url" fit="fill"></el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" width="300" label="题库名称" prop="title">
        </el-table-column>
        <el-table-column align="center" label="所属科目" prop="subjectName">
        </el-table-column>
        <el-table-column align="center" label="题目数量" prop="question_num">
        </el-table-column>
        <el-table-column align="center" label="来源" prop="">
          <template slot-scope="scope">
            <span v-if="scope.row.sourceInfo != null">{{ scope.row.sourceInfo.title }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="分项" prop="">
          <template slot-scope="scope">
            <span v-if="scope.row.tagRelationInfoArr != 0">
              <span v-for="(item, index) in scope.row.tagRelationInfoArr" :key="index">
                {{ item.tagInfo.title }}
              </span>
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="发布状态" prop="post_state">
          <template slot-scope="scope">
            <el-tag size="mini" effect="dark" v-if="scope.row.post_state == 0" type="info">未发布</el-tag>
            <el-tag size="mini" effect="dark" v-else-if="scope.row.post_state == 1" type="success">已启用</el-tag>
            <el-tag size="mini" effect="dark" v-else-if="scope.row.post_state == 2" type="danger">已停用</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" width="150" label="创建时间" prop="created_time">
        </el-table-column>

        <el-table-column align="center" label="管理" width="300">
          <template slot-scope="scope">
            <el-link class="quest_btn" type="primary" @click="QuestionManagement(scope.row)">试题管理</el-link>
            <el-link class="quest_btn" type="primary" @click="AddQuestion(scope.row)"
              :disabled="form1.is_admin == '2'">添加试题</el-link>
            <!-- <el-link class="quest_btn" type="primary" @click="Practice(scope.row)">练习</el-link> -->
            <el-link class="quest_btn" type="primary" @click="QuestionBank(scope.row)"
              :disabled="form1.is_admin == '2'">编辑</el-link>
            <el-link class="quest_btn" type="primary" @click="adminDeleteQuestionBank(scope.row.id)"
              :disabled="form1.is_admin == '2'">删除</el-link>
          </template>
        </el-table-column>

        <el-table-column align="center" label="发布/停用" fixed="right" width="100">
          <template slot-scope="scope">
            <el-link class="quest_btn" type="primary" @click="adminChangeQuestionBankPostState(scope.row.id, '1')"
              :disabled="form1.is_admin == '2'">发布</el-link>
            <el-link class="quest_btn" type="primary" @click="adminChangeQuestionBankPostState(scope.row.id, '2')"
              :disabled="form1.is_admin == '2'">停用</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no"
        layout="total, prev, pager, next" :page-size="page_size" :total="total"></el-pagination>
    </div>

    <el-dialog :title="dialog_title" :visible.sync="dialogVisible" width="40%">
      <el-form class="form-style" :model="form" size="mini" label-position="left">
        <el-form-item label="序号" required>
          <el-input-number v-model="form.sort_num" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="所属科目" required>
          <el-select v-model="form.subject_id" placeholder="请选择" filterable>
            <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="* 题库来源">
          <el-select @change="changeSourse" v-model="form.source_id" filterable placeholder="请选择" clearable>
            <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="* 分项">
          <el-select v-model="form.source_id1" filterable placeholder="请选择" clearable
            :disabled="options1.length != 0 ? false : true">
            <el-option v-for="item in options1" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="* 年份">
          <el-select v-model="form.year" filterable placeholder="请选择" clearable>
            <el-option v-for="item in options2" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="题库名称" required>
          <el-input v-model="form.title" placeholder="请输入名称"></el-input>
        </el-form-item>

        <el-form-item label="简介" required>
          <el-input type="textarea" v-model="form.desc" placeholder="请输入题库的简介"></el-input>
        </el-form-item>

        <el-form-item label="封面" required>
          <el-upload action="" :http-request="uploadFile" :on-remove="handleRemove" :on-change="handleChangeFile"
            :auto-upload="false" :limit="1" :file-list="form.imgList" list-type="picture">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
            <div slot="tip" class="el-upload__tip">
              <span style="color: red">推荐尺寸(750*340)</span>
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="adminAddOrUpdateQuestionBank">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import {
  getSubjectList,
  adminAddOrUpdateQuestionBank,
  adminGetQuestionBankList,
  adminDeleteQuestionBank,
  adminChangeQuestionBankPostState,
  adminGetTestQuestionBankSourceListWit,
  adminGetTestQuestionBankSourceTagListWithoutPage,
  adminGetTestQuestionBankYearListWithoutPage

} from "@/api/admin";
import uploadFile from "@/config/uploadFile";
export default {
  name: "platform-question-admin",
  data() {
    return {
      options2: [],
      options: [],
      subject_state: 1,
      uploadFileTime: false,
      dialog_title: "新增题库",
      options1: [],
      questionlist: [],

      form: {
        year: '',
        id: "",
        sort_num: 1,
        title: "",
        subject_id: "",
        source_id: '',
        desc: "",
        img_url: "",
        imgList: [],
        schoolId: '',
        source_id1: ''
      },

      form1: {
        is_admin: '1',
        subject_id: "",
        title: "",
        source_id: '',
      },

      subjectList: [],
      dialogVisible: false, //新增题库
      input: "",
      page_no: 1,
      page_size: 20,
      total: 0,
    };
  },
  watch: {
    dialogVisible(value) {
      console.log(value, 222344);
      if (value == true) {
        this.adminGetTestQuestionBankYearListWithoutPage()
      }
    },
    'form.source_id'(val) {
      console.log(val, 13246546)
      if (val) {
        this.adminGetTestQuestionBankSourceTagListWithoutPage()
      }
    }
  },
  activated() {
    this.adminGetQuestionBankList()


  },
  mounted() {
    this.getSubjectList();
    this.adminGetQuestionBankList();

    this.adminGetTestQuestionBankSourceListWit()
  },


  methods: {
    changeSourse(val) {
      console.log(val, 123465)
    },
    adminGetTestQuestionBankSourceTagListWithoutPage() {
      adminGetTestQuestionBankSourceTagListWithoutPage({
        source_id: this.form.source_id
      }).then((res) => {
        console.log(res, 12346545678)
        this.options1 = res.testQuestionBankSourceTagList
      })
    },
    search() {
      this.page_no = 1
      this.adminGetQuestionBankList()
    },
    changeList() {
      this.page_no = 1
      this.adminGetQuestionBankList()
    },

    //来源列表
    adminGetTestQuestionBankSourceListWit() {
      adminGetTestQuestionBankSourceListWit().then((res) => {
        console.log(res, 95656);
        this.options = res.testQuestionBankSourceList

      })
    },
    //
    adminGetTestQuestionBankYearListWithoutPage() {
      adminGetTestQuestionBankYearListWithoutPage().then((res) => {
        this.options2 = res.testQuestionBankYearList

      })
    },
    addproblem() {
      this.dialogVisible = true
      this.form = {}
      this.form.sort_num = 1

    },
    //添加题库
    adminAddOrUpdateQuestionBank() {
      if (this.form.id) {
        this.dialog_title = "修改题库";
        adminAddOrUpdateQuestionBank({
          questionBankId: this.form.id,
          subject_id: this.form.subject_id,
          source_id: this.form.source_id,
          title: this.form.title,
          content: this.form.desc,
          sort_num: this.form.sort_num,
          cover_url: this.form.imgList[0].url,
          schoolId: this.form.schoolId,
          year_id: this.form.year,
          tagIdArr: JSON.stringify([this.form.source_id1])

        }).then((res) => {
          console.log("更新成功");
          console.log(res);
          if (res.is_update) {
            this.$message.success("更新成功");
            this.dialogVisible = false;
            this.adminGetQuestionBankList();
          }
        });
      } else {
        this.dialog_title = "新增题库";
        adminAddOrUpdateQuestionBank({
          subject_id: this.form.subject_id,
          source_id: this.form.source_id,
          title: this.form.title,
          content: this.form.desc,
          sort_num: this.form.sort_num,
          cover_url: this.form.imgList[0].url,
          year_id: this.form.year,
          tagIdArr: JSON.stringify([this.form.source_id1])
        }).then((res) => {
          console.log("添加题库");
          console.log(res);
          if (res.is_created) {
            this.$message.success("添加成功");
            this.dialogVisible = false;
            this.adminGetQuestionBankList();
            this.form = {};
          }
        });
      }
    },

    //查询题库
    adminGetQuestionBankList() {
      adminGetQuestionBankList({
        is_admin: this.form1.is_admin,
        source_id: this.form1.source_id,
        subject_id: this.form1.subject_id,
        title: this.form1.title,
        post_state: "",
        educational_institution_id: "",
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log("查询平台题库");
        console.log(res);
        this.questionlist = res.questionBankList;
        this.total = res.total;
      });
    },

    getSubjectList() {
      getSubjectList(
        {
          subject_state: this.subject_state,
          page_no: 1,
          page_size: 100,
        },
        true
      ).then((res) => {
        console.log("平台科目");
        console.log(res, 152121);
        this.subjectList = res.subject_list;
      });
    },

    //编辑题库
    QuestionBank(row) {
      console.log("编辑题库");
      console.log(row, 789456456);
      this.form.schoolId = row.educational_institution_id
      this.dialogVisible = true;
      if (row.sourceInfo != undefined) {
        this.form.source_id = row.sourceInfo.id
      }
      // 
      this.form.id = row.id;
      this.form.sort_num = row.sort_num;
      this.form.subject_id = row.subject_id;
      this.form.title = row.title;
      this.form.desc = row.content;
      this.form.year = row.year_id
      if (row.tagRelationInfoArr.length != 0) {
        row.tagRelationInfoArr.map((item) => {
          this.form.source_id1 = item.tagInfo.id
        })
      } else {
        this.form.source_id1 = ''
      }
      this.form.imgList = [
        {
          url: row.cover_url,
          name: row.cover_url.split("/")[row.cover_url.split("/").length - 1],
        },
      ];
    },

    adminDeleteQuestionBank(id) {
      this.$confirm("确定删除该题库吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        adminDeleteQuestionBank({
          questionBankId: id,
        }).then((res) => {
          console.log("删除题库");
          console.log(res);
          if (res.is_delete) {
            this.$message.success("删除成功");
            this.adminGetQuestionBankList();
          }
        });
      });
    },
    //发布状态
    adminChangeQuestionBankPostState(id, cmd) {
      adminChangeQuestionBankPostState({
        questionBankId: id,
        post_state: cmd,
      }).then((res) => {
        console.log("题库发布状态");
        console.log(res);

        this.adminGetQuestionBankList();
      });
    },

    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList);
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true;
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log("上传图片");
          console.log(res);
          this.form.imgList = res;
          this.uploadFileTime = false;
        }
      );
    },

    //添加试题
    AddQuestion(row) {
      console.log("添加试题");
      console.log(row);
      this.$router.push({
        name: "add-question-admin",
        query: {
          id: row.id,
          title: row.title,
          subject_id: row.subject_id,
          question_num: row.question_num,
          type: '1'
        },
      });
    },
    QuestionManagement(row) {
      console.log("试题管理");
      console.log(row);
      this.$router.push({
        name: "questionlist-admin",
        query: {
          id: row.id,
          title: row.title,
          subject_id: row.subject_id,
          question_num: row.question_num,

        },
      });
    },
    Practice(row) {
      console.log("练习");
      console.log(row);
      this.$router.push({
        name: "practice",
        query: {
          id: row.id,
          title: row.title,
        },
      });
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.adminGetQuestionBankList();
    },
    handleRemove() { },
    uploadFile() { },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-top: 5px;
  background: white;
  border-radius: 5px;

  .header {
    .search {
      width: 250px;
    }

    .search_btn {
      margin-left: 20px;
    }
  }

  .question_wrapper {
    .quest_btn {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
}
</style>